/******/ (() => { // webpackBootstrap
/******/ 	"use strict";

;// ./src/js/WqAxeptio.js
/* To use this class, please import it into your main.js and
 * configure window.axeptioSettings with your Axeptio credentials in main.js
 * https://support.axeptio.eu/hc/fr/articles/17628559386641-Plugin-Axeptio-Shopify
 *
 * window.axeptioSettings = {
      clientId: 'PASTE HERE YOUR AXEPTIO clientId',
      cookiesVersion: 'PASTE HERE YOUR AXEPTIO cookiesVersion',
    };
 */

class WqAxeptio {
  init() {
    if (
      window.axeptioSettings?.clientId &&
      window.axeptioSettings?.cookiesVersion
    ) {
      this.loadAxeptio();
    }
  }

  loadAxeptio() {
    window.Shopify.loadFeatures(
      [
        {
          name: 'consent-tracking-api',
          version: '0.1',
        },
      ],
      (error) => {
        if (error) {
          // Rescue error
        }
        // If error is false, the API has loaded and ready to use!
      }
    );

    (function (d, s) {
      var t = d.getElementsByTagName(s)[0],
        e = d.createElement(s);
      e.async = true;
      e.src = '//static.axept.io/sdk.js';
      t.parentNode.insertBefore(e, t);
    })(document, 'script');

    void 0 === window._axcb && (window._axcb = []);

    window._axcb.push(function (axeptio) {
      axeptio.on('cookies:complete', function (choices) {
        window.Shopify.customerPrivacy.setTrackingConsent(
          {
            marketing: choices.shopify_marketing,
            analytics: choices.shopify_performance,
            preferences: choices.shopify_preferences,
          },
          () => {}
        );
      });
    });
  }
}

;// ./src/js/utils/DataLayerPush.js
const dataLayerPush = (eventName, data) => {
  return new Promise((resolve, reject) => {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: `${eventName}`,
        ...data,
      });
      resolve();
    } catch (error) {
      reject(error);
    }
  });
};



;// ./src/js/enums/DataLayerEventsEnum.js
const DataLayerEventsEnum = Object.freeze({
  SelectProduct: 'click_item_ta',
  AddToWishList: 'add_to_wishlist_ta',
  ConfiguratorStart: 'start_personalization_ta',
  ConfiguratorSelectCategory: 'customize_category_ta',
  ConfiguratorSelectProduct: 'customize_product_ta',
  ConfiguratorSelectTheme: 'customize_visual_ta',
  ConfiguratorAddToCart: 'add_to_cart_ta',
  ContactForm: 'contact_ta',
  SubscribeNewsletter: 'subscribe_newsletter_ta',
  QuoteForm: 'generate_lead_ta',
});

;// ./src/js/Configurator.js



class Configurator {
  constructor() {
    this.quantity = 1;
    this.productHandle = null;
    this.iframeSelector = 'iframe.configurator';
    this.redirectUrl = null;
    this.productName = '';
  }

  init = () => {
    this.iframe = document.querySelector(this.iframeSelector);
    if (!this.iframe) return;

    const urlParams = new URLSearchParams(window.location.search);
    const currentTheme = urlParams.get('skuTheme');

    if (currentTheme) {
      this.iframe.src = `${this.iframe.src}?skuTheme=${currentTheme}`;
    }

    const previousUrlDomain = this.getUrlDomain(document.referrer);
    const currentUrlDomain = this.getUrlDomain(window.location.href);

    if (previousUrlDomain === currentUrlDomain) {
      this.redirectUrl = document.referrer;
    } else {
      this.redirectUrl = window.Shopify.routes.root;
    }

    window.addEventListener('message', async (message) => {
      const data = JSON.parse(message.data);
      if (data.eventType === 'addToCart') {
        await this.addToCart(data);
      }
      if (data.eventType === 'askVariantsData') {
        await this.askVariantsData(data);
      }
      if (data.eventType === 'redirect') {
        window.location.href = this.redirectUrl;
      }
    });
  };

  askVariantsData = async (data) => {
    if (!data) return;

    this.productHandle = window.Shopify.customVariables?.productHandle;

    // If current page isnt a product page
    if (this.productHandle === undefined) {
      await this.getProductHandle(data.variantRefs[0]);
    }

    const product = await this.getProductDetails(this.productHandle);
    const variantRefs = data.variantRefs;

    // Get variant prices
    let formattedVariantsData = product.variants.map((variant) => {
      const unitPrice = (variant.price / Number(variant.title)) * 0.01;
      const currentPrice = variant.price * 0.01;
      return {
        variantRef: variant.sku,
        prices: {
          currentPrice: `${currentPrice.toFixed(2)}€`,
          unitPrice: `${unitPrice.toFixed(2)}€`,
        },
      };
    });

    // Remove items that are not known by configurator (variantRefs)
    formattedVariantsData = formattedVariantsData.filter((product) =>
      variantRefs.includes(product.variantRef)
    );

    // Set price for each configurator variant
    const messageIframe = JSON.stringify({
      eventType: 'sendVariantsData',
      variantsData: formattedVariantsData,
    });

    this.iframe.contentWindow.postMessage(messageIframe, '*');
  };

  getProductHandle = async (productSku) => {
    try {
      const response = await fetch(
        window.Shopify.routes.root +
          `search/suggest.json?q=${productSku}&resources[type]=product&resources[options][fields]=variants.sku`
      );
      const product = await response.json();
      this.productHandle = product?.resources?.results?.products[0]?.handle;
    } catch (error) {
      console.log('Error on predictive search', error);
    }
  };

  getProductDetails = async (handle) => {
    try {
      const response = await fetch(
        `${window.Shopify.routes.root}products/${handle}.js`
      );
      return await response.json();
    } catch (error) {
      console.log('Error while fetching product', error);
    }
  };

  addToCart = async (data) => {
    if (data && data.variantRef) {
      let productId = null;
      this.productHandle = window.Shopify.customVariables?.productHandle;
      const splitVariantRef = data.variantRef.split('-');

      // Check if initial product loaded in configurator is the same on final product on configurator
      if (
        window.Shopify.customVariables?.sku !== splitVariantRef[0] ||
        this.productHandle === undefined
      ) {
        await this.getProductHandle(splitVariantRef[0]);
      }

      this.quantity = splitVariantRef[1] ? splitVariantRef[1] : 1;

      // If configurator is loaded on product page, get all variants from product for compare with quantity
      if (this.productHandle) {
        const product = await this.getProductDetails(this.productHandle);
        product?.variants.forEach((variant) => {
          if (Number(variant.title) === Number(this.quantity)) {
            productId = variant.id;
          }
        });
      }

      const completeSku = data.themeSku
        ? `${splitVariantRef[0]}-${data.themeSku}`
        : splitVariantRef[0];

      this.realProductName = await this.getProductName(completeSku);

      const formData = {
        items: [
          {
            id: productId,
            quantity: 1,
            properties: {
              // Replace spaces in file name
              _screenShot: data.record?.screenshotDownloadLinks[1].replace(
                / /g,
                '%20'
              ),
              _screenShot1: data.record?.screenshotDownloadLinks[0].replace(
                / /g,
                '%20'
              ),
              _screenShot2: data.record?.screenshotDownloadLinks[2].replace(
                / /g,
                '%20'
              ),
              _completeSku: completeSku,
              _bat: data.record?.printFileDownloadLink,
              _fileName: data.record?.printFileName,
              _quantity: Number(this.quantity),
            },
          },
        ],
      };

      if (productId) {
        this.addToCartShopifyApi(formData);
      }
    }
  };

  addToCartShopifyApi(formData) {
    fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then(async (response) => {
        if (response.ok) {
          const data = await response.json();
          return dataLayerPush(DataLayerEventsEnum.ConfiguratorAddToCart, {
            category_name: '', // Todo: return category_name
            product_name: '', // Todo: return product_name
            atc_type: 'configurateur',
            ecommerce: {
              items: [
                {
                  item_id: data.items[0].product_id,
                  item_variant_id: data.items[0].variant_id,
                  item_name: this.realProductName,
                  sku: formData.items[0].properties._completeSku,
                  discount:
                    Number(data.items[0].final_price) -
                    Number(data.items[0].discounted_price),
                  price: data.items[0].final_price,
                  item_brand: 'Boutique Gobelets',
                  item_category: formData.items[0].properties._completeSku, // Todo: return category name
                  quantity: formData.items[0].quantity,
                },
              ],
            },
          });
        }
      })
      .then(() => {
        window.location.href = '/cart';
      })
      .catch((error) => {
        console.error(`Error: ${error}`);
      });
  }

  getUrlDomain = (url) => {
    try {
      const urlObj = new URL(url);
      return urlObj.hostname;
    } catch (error) {
      console.log(error);
    }
  };

  getProductName = (sku) => {
    return fetch(
      window.Shopify.routes.root +
        `search/suggest.json?q=${sku}&resources[type]=product&resources[options][unavailable_products]=hide&resources[options][fields]=variants.sku`
    )
      .then((response) => response.json())
      .then((suggestions) => {
        const productSuggestions = suggestions.resources.results.products;
        if (productSuggestions.length > 0) {
          const firstProductSuggestion = productSuggestions[0];
          return firstProductSuggestion.title;
        }
      });
  };
}

;// ./src/js/CupSwitcher.js
class CupSwitcher {
  constructor() {
    this.productListSelector = '.shopify-section--main-collection';
    this.cupSwitcherSelector = '.cup-switcher';
    this.cupSwitchers = new Set();
  }
  init() {
    this.getCupSwitchers();

    const productListSelector = document.querySelector(
      this.productListSelector
    );
    if (!productListSelector) return;

    const observer = new MutationObserver((mutationList) => {
      let shouldUpdate = false;

      mutationList.forEach((mutation) => {
        if (mutation.type === 'childList') {
          // Save in new Set, fresh filtered products
          const newSwitchers = new Set(
            document.querySelectorAll(this.cupSwitcherSelector)
          );

          // If original set != new set, replace orignal set with new one
          if (!this.areSetsEqual(this.cupSwitchers, newSwitchers)) {
            shouldUpdate = true;
            this.cupSwitchers = newSwitchers;
          }
        }
      });

      if (shouldUpdate) {
        this.getCupSwitchers();
      }
    });

    observer.observe(productListSelector, { childList: true, subtree: true });
  }

  getCupSwitchers = () => {
    const newSwitchers = document.querySelectorAll(this.cupSwitcherSelector);
    if (!newSwitchers.length > 0) return;

    newSwitchers.forEach((cupSwitcher) => {
      if (!this.cupSwitchers.has(cupSwitcher)) {
        this.cupSwitchers.add(cupSwitcher);
      }
    });

    this.handleCupSwitcher();
  };

  handleCupSwitcher = () => {
    for (const cupSwitcher of this.cupSwitchers) {
      const toggleButton = cupSwitcher.querySelector(
        '.cup-switcher__button--toggle'
      );
      const fullList = cupSwitcher.querySelector('.cup-switcher__full-list');
      const configureButton = cupSwitcher.querySelector(
        '.cup-switcher__configure'
      );
      const itemButtons = cupSwitcher.querySelectorAll(
        '.cup-switcher__button:not(.cup-switcher__button--toggle)'
      );
      const items = cupSwitcher.querySelectorAll(
        '.cup-switcher__full-list-item:not(:first-child)'
      );

      if (toggleButton && fullList && configureButton && itemButtons && items) {
        for (const itemButton of itemButtons) {
          itemButton.addEventListener('click', () => {
            // Reset state of each main button
            itemButtons.forEach((button) =>
              button.classList.remove('cup-switcher__button--active')
            );
            // Reset state of each toggle list items
            items.forEach((item) =>
              item.classList.remove('cup-switcher__full-list-item--active')
            );
            this.selectItem(itemButton, toggleButton);
            this.toggleFullList(toggleButton, fullList, true); // Close toggle list
            this.updateButtonUrl(configureButton, itemButton);
          });
        }

        toggleButton.addEventListener('click', () => {
          this.toggleFullList(toggleButton, fullList);
        });
      }
    }
  };

  selectItem(itemButton, toggleButton) {
    itemButton.classList.toggle('cup-switcher__button--active');
    toggleButton.classList.remove('cup-switcher__button--active');
  }

  toggleFullList(toggleButton, fullList, forceClose = false) {
    if (forceClose) {
      toggleButton.classList.remove('cup-switcher__button--toggle-active');
      fullList.classList.remove('cup-switcher__full-list--show');
    } else {
      toggleButton.classList.toggle('cup-switcher__button--toggle-active');
      fullList.classList.toggle('cup-switcher__full-list--show');
    }
  }

  updateButtonUrl(configureButton, item) {
    if (configureButton.dataset.url !== item.dataset.url) {
      configureButton.href = item.dataset.url;
    }
  }

  // Compare 2 Set
  areSetsEqual = (setA, setB) => {
    if (setA.size !== setB.size) return false;
    for (const item of setA) {
      if (!setB.has(item)) return false;
    }
    return true;
  };
}

;// ./src/js/HelpBlock.js
class HelpBlock {
  constructor() {
    this.blockSelector = '.help-block';
    this.optionsSelector = '.help-block__option';
    this.checkboxSelector = '.help-block__option-radio';
    this.disabledModifier = 'help-block__option--disabled';
    this.selectedModifier = 'help-block__option--selected';
    this.optionsButtonSelector = '.help-buttons__button';
    this.addToCartButtonSelector = '.help-buttons__button--first';
    this.configuratorButtonSelector = '.product-info__configurator-button';
    this.formSelector = '.help-block__form > form';
    this.formSubmit = '.help-block__submit';
  }
  init() {
    const helpBlock = document.querySelector(this.blockSelector);
    if (!helpBlock) return;

    this.helpBlockOptions = helpBlock.querySelectorAll(this.optionsSelector);
    if (!this.helpBlockOptions?.length > 0) return;

    this.configuratorButton = document.querySelector(
      this.configuratorButtonSelector
    );

    this.optionsButton = document.querySelectorAll(this.optionsButtonSelector);
    if (!this.optionsButton?.length > 0) return;

    this.addToCartButton = document.querySelector(this.addToCartButtonSelector);
    if (!this.addToCartButton) return;

    this.form = document.querySelector(this.formSelector);
    if (!this.formSelector) return;

    for (const helpBlockOption of this.helpBlockOptions) {
      const checkbox = helpBlockOption.querySelector(this.checkboxSelector);
      if (!checkbox) continue;

      checkbox.addEventListener('change', () => {
        this.manageOptions(checkbox);
      });
    }

    this.addToCartButton.addEventListener('click', (event) => {
      this.addToCart(event);
    });
  }

  manageOptions(clickedOption) {
    if (this.configuratorButton) {
      clickedOption.checked
        ? (this.configuratorButton.style.display = 'none')
        : (this.configuratorButton.style.display = 'inline-flex');
    }

    const optionsArray = Array.from(this.helpBlockOptions);

    for (const currentOption of this.helpBlockOptions) {
      const checkbox = currentOption.querySelector(this.checkboxSelector);
      const otherOption = optionsArray.find(
        (option) => option !== currentOption
      );

      if (window.innerWidth > 500) {
        if (checkbox.checked) {
          otherOption.classList.add(this.disabledModifier);
        } else {
          otherOption.classList.remove(this.disabledModifier);
        }
      } else {
        if (checkbox.checked) {
          otherOption.style.display = 'none';
          currentOption.classList.add(this.selectedModifier);
        } else {
          otherOption.style.display = 'flex';
          currentOption.classList.remove(this.selectedModifier);
        }
      }
    }

    if (clickedOption.checked) {
      const substrings = ['--first', '--second'];
      this.optionsButton.forEach((optionButton) => {
        substrings.forEach((substring) => {
          if (
            this.findSubString(clickedOption, substring) &&
            this.findSubString(optionButton, substring)
          ) {
            optionButton.style.display = 'inline-flex';

            // Show form
            if (substring === '--first') {
              this.form.style.display = 'flex';
            }
          }
        });
      });
    } else {
      this.optionsButton.forEach(
        (optionButton) => (optionButton.style.display = 'none')
      );
      this.form.style.display = 'none';
    }
  }

  findSubString = (element, subString) => {
    return Array.from(element.classList).some((className) =>
      className.includes(subString)
    );
  };

  addToCart = (event) => {
    event.preventDefault();

    const submit = this.form.querySelector(this.formSubmit);
    if (!submit) return;

    // Reset for avoid errors
    this.form.removeEventListener('submit', this.handleFormSubmit);

    this.form.addEventListener('submit', this.handleFormSubmit);

    submit.click();
  };

  handleFormSubmit = async (formEvent) => {
    formEvent.preventDefault();

    const form = formEvent.target;

    // If required fields are filled
    if (form.checkValidity()) {
      await this.addMainProductToCartAPI(form);
      await this.addOptionToCart();
    } else {
      // Show navigator errors on fields
      form.reportValidity();
    }

    form.removeEventListener('submit', this.handleFormSubmit);
  };

  addMainProductToCartAPI = async (form) => {
    const formData = new FormData(form);
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        body: formData,
      });

      if (response && response.ok) {
        return response.json();
      }
    } catch (error) {
      console.error('Error adding main product to cart:', error);
    }
  };

  addOptionToCart = async () => {
    const formData = {
      items: [
        {
          id: Shopify.customVariables?.createFromYourOptionProduct,
          quantity: 1,
        },
      ],
    };

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response && response?.ok) {
        window.location.href = '/cart';
      }
    } catch (error) {
      console.log('error on addOption', error);
    }
  };
}

;// ./src/js/Product.js



class Product {
  constructor() {
    this.quantity = 1;
    this.configuratorButtonSelector =
      '.product .product-info__configurator-button';
    this.cupQuantityPriceSelector = '.cup-quantity-price';
    this.cupQuantityListShowModifier = 'cup-quantity-price__list--show';
    this.addToCartButtonSelector = '.product-info__add-to-cart-button';
    this.popinSelector = '.product-popin';
    this.closePopinButtonSelector = '.product-popin__close';
    this.popinInputsSelector = '.product-popin__input';
    this.popinSubmitSelector = '.product-popin__submit';
    this.hiddenInputQuantitySelector = '#help-block__quantity';
    this.hiddenInputSkuSelector = '#help-block__completeSku';
  }

  init = () => {
    const hiddenInputQuantity = document.querySelector(
      this.hiddenInputQuantitySelector
    );
    const hiddenInputSkuSelector = document.querySelector(
      this.hiddenInputSkuSelector
    );

    if (hiddenInputQuantity && hiddenInputSkuSelector) {
      document.body.addEventListener('variant:change', (e) => {
        hiddenInputQuantity.value = e.detail.variant.title;
        hiddenInputSkuSelector.value = e.detail.variant.sku;
      });
    }

    this.configuratorButton = document.querySelector(
      this.configuratorButtonSelector
    );

    this.addToCartButton = document.querySelector(this.addToCartButtonSelector);
    if (this.addToCartButton) {
      this.addToCartButton.addEventListener(
        'click',
        this.handleAddToCartButton
      );
    }

    this.cupQuantityPrice = document.querySelector(
      this.cupQuantityPriceSelector
    );
    if (!this.cupQuantityPrice) return;

    this.handleCupQuantityPrice();
  };

  handleCupQuantityPrice = () => {
    this.selectActive = this.cupQuantityPrice.querySelector(
      '.cup-quantity-price__select-active'
    );
    this.selectActiveLabel = this.cupQuantityPrice.querySelector(
      '.cup-quantity-price__select-active-label'
    );
    this.itemList = this.cupQuantityPrice.querySelector(
      '.cup-quantity-price__list'
    );
    this.priceListUnit = this.cupQuantityPrice.querySelector(
      '.price-list__unit-price-number'
    );
    this.priceListTotal = this.cupQuantityPrice.querySelector(
      '.price-list__total-price'
    );

    if (
      !this.selectActive &&
      !this.selectActiveLabel &&
      !this.itemList &&
      !this.priceListUnit &&
      !this.priceListTotal
    )
      return;

    this.toggleList();

    this.items = this.cupQuantityPrice.querySelectorAll(
      '.cup-quantity-price__item'
    );
    if (!this.items) return;

    this.selectItem();
  };

  toggleList = () => {
    this.selectActive.addEventListener('click', () => {
      if (this.itemList.classList.contains(this.cupQuantityListShowModifier)) {
        this.itemList.classList.remove(this.cupQuantityListShowModifier);
      } else {
        this.itemList.classList.add(this.cupQuantityListShowModifier);
      }
    });
  };

  selectItem = () => {
    this.items.forEach((item) => {
      item.addEventListener('click', () => {
        // Delete all active classes
        this.items.forEach((i) =>
          i.classList.remove('cup-quantity-price__item--active')
        );

        // Add active class on clicked element
        item.classList.add('cup-quantity-price__item--active');

        this.selectActiveLabel.textContent = item.dataset.quantity;

        // Close list
        this.itemList.classList.remove(this.cupQuantityListShowModifier);

        this.quantity = item.dataset.quantity;
        this.calculPrice(item.dataset.total, item.dataset.unit);
        this.updateButtonUrl();
      });
    });
  };

  calculPrice = (total, unit) => {
    this.priceListTotal.textContent = total;
    this.priceListUnit.textContent = unit;
  };

  updateButtonUrl = () => {
    if (!this.configuratorButton) return;
    let url = this.configuratorButton.href;

    this.configuratorButton.addEventListener('click', (e) => {
      e.preventDefault();
      if (url.includes('?quantity')) {
        url = url.replace(/(&quantity=)\d{1,4}/, `$1${this.quantity}`);
      } else {
        url = url.concat(`&quantity=${this.quantity}`);
      }
      window.location = url;
    });
  };

  handleAddToCartButton = () => {
    const productParent = window.themeVariables.product.parentProduct;
    const popin = document.querySelector(this.popinSelector);
    const inputProperties = {};

    const parentVariant = productParent.variants.find(
      (variant) => variant.title === this.quantity.toString()
    );

    const formData = {
      items: [
        {
          id: parentVariant.id,
          quantity: 1,
          properties: {
            _screenShot: window.themeVariables.product.image,
            _completeSku: window.themeVariables.product.sku,
            _title: window.themeVariables.product.title,
            _quantity: Number(this.quantity),
          },
        },
      ],
    };

    if (popin) {
      this.handleClosePopin(popin);
      popin.classList.add('product-popin--reveal');
      this.popinInputs = popin.querySelectorAll(this.popinInputsSelector);
      this.popinSubmit = popin.querySelector(this.popinSubmitSelector);
      if (!this.popinInputs.length > 0 || !this.popinSubmit) return;

      let uploadedImages = {};
      let nbOfUploadedImages = 1;

      window.addEventListener('upload:added', (event) => {
        uploadedImages[`image${nbOfUploadedImages}`] = event.detail.url;
        nbOfUploadedImages++;
      });

      this.popinInputs.forEach((input) => {
        input.addEventListener('input', this.validateForm);
      });

      this.popinSubmit.addEventListener('click', () => {
        this.popinInputs.forEach((input) => {
          inputProperties[`${input.id}`] =
            `${input.dataset.label}: ${input.value}`;
        });

        formData.items[0].properties = {
          ...formData.items[0].properties,
          ...inputProperties,
          ...uploadedImages,
        };

        this.addToCart(formData);
      });
    }
  };

  addToCart = (formData) => {
    fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then(async (response) => {
        if (response.ok) {
          const data = await response.json();
          return dataLayerPush(DataLayerEventsEnum.ConfiguratorAddToCart, {
            category_name: '', // Todo: return category_name
            product_name: '', // Todo: return product_name
            atc_type: 'configurateur',
            ecommerce: {
              items: [
                {
                  item_id: data.items[0].product_id,
                  item_variant_id: data.items[0].variant_id,
                  item_name: formData.items[0].properties._title,
                  sku: formData.items[0].properties._completeSku,
                  discount:
                    Number(data.items[0].final_price) -
                    Number(data.items[0].discounted_price),
                  price: data.items[0].final_price,
                  item_brand: 'Boutique Gobelets',
                  item_category: formData.items[0].properties._completeSku, // Todo: return category name
                  quantity: formData.items[0].quantity,
                },
              ],
            },
          });
        }
      })
      .then(() => {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        window.location.href = '/cart';
      })
      .catch((error) => {
        console.error(`Error: ${error}`);
      });
  };

  validateForm = () => {
    const allInputsFilled = Array.from(this.popinInputs).every(
      (input) => input.value.trim() !== ''
    );

    if (allInputsFilled) {
      this.popinSubmit.classList.remove('product-popin__submit--disabled');
      this.popinSubmit.disabled = false;
    } else {
      this.popinSubmit.classList.add('product-popin__submit--disabled');
      this.popinSubmit.disabled = true;
    }
  };

  handleClosePopin = (popin) => {
    const closeButton = popin.querySelector(this.closePopinButtonSelector);
    if (!closeButton) return;

    closeButton.addEventListener('click', () => {
      popin.classList.remove('product-popin--reveal');
    });
  };
}

;// ./src/js/DataLayer.js



class DataLayer {
  constructor() {
    this.configuratorSelector = 'iframe.configurator';
    this.wishlistButtonSelector = '.wishlist-engine';
    this.productCardsSelector = '.product-card';
    this.footerNewsletterSelector = '#footer-newsletter';
    this.footerNeswletterInputSelector = '.footer__newsletter-input';
  }

  init = () => {
    const configurator = document.querySelector(this.configuratorSelector);
    if (configurator) {
      this.handleStartConfigurator();
    }

    setTimeout(() => {
      const wishlistButtons = document.querySelectorAll(
        this.wishlistButtonSelector
      );
      if (wishlistButtons.length > 0) {
        wishlistButtons.forEach((wishlistButton) => {
          wishlistButton.addEventListener('click', () => {
            if (wishlistButton.dataset.added === 'false') {
              this.handleWishlistEvent(wishlistButton);
            }
          });
        });
      }
    }, 200);

    const productCards = document.querySelectorAll(this.productCardsSelector);
    if (productCards.length > 0) {
      productCards.forEach((productCard) => {
        this.handleSelectProduct(productCard);
      });
    }

    const footerNewsletter = document.querySelector(
      this.footerNewsletterSelector
    );
    if (footerNewsletter) {
      this.handleNewsletterEvent(footerNewsletter);
    }
  };

  handleStartConfigurator = () => {
    dataLayerPush(DataLayerEventsEnum.ConfiguratorStart)
      .then(() => {})
      .catch((error) => {
        console.error(error);
      });
  };

  handleWishlistEvent = (button) => {
    const productInfo = document.querySelector('.product-info');
    let productTitle = '';
    let productSku = '';
    let productCategory = '';

    if (productInfo) {
      productTitle = window.themeVariables.product.title;
      productSku = window.themeVariables.product.sku;
      productCategory = window.themeVariables.product.category;
    } else {
      const productCard = button.parentNode.closest('product-card');
      productTitle = productCard.dataset.title;
      productSku = productCard.dataset.sku;
      productCategory = productCard.dataset.category;
    }

    const productId = button.dataset.product_id;
    const variantId = button.dataset.variant_id;

    dataLayerPush(DataLayerEventsEnum.AddToWishList, {
      ecommerce: {
        items: [
          {
            item_id: productId,
            item_variant_id: variantId,
            item_name: productTitle,
            sku: productSku,
            item_brand: 'Boutique Gobelets',
            item_category: productCategory,
            quantity: 1,
          },
        ],
      },
    })
      .then(() => {})
      .catch((error) => {
        console.error(error);
      });
  };

  handleSelectProduct = (productCard) => {
    const productCardLinks = productCard.querySelectorAll('a');
    if (!productCardLinks.length > 0) return;

    productCardLinks.forEach((productCardLink) => {
      let clickType = '';
      let url = '';

      productCardLink.addEventListener('click', (event) => {
        event.preventDefault();
        let link = '';

        if (event.target.href) {
          link = event.target;
        } else {
          link = event.target.parentNode.closest('a');
        }

        if (link === '') return;

        if (link.dataset.href || link.href.includes('configurator')) {
          clickType = 'configurateur';
          if (link.dataset.href) {
            url = atob(link.dataset.href);
          } else {
            url = link.href;
          }
        } else {
          clickType = 'page produit';
          url = link.href;
        }

        if (clickType !== '' && url !== '')
          dataLayerPush(DataLayerEventsEnum.SelectProduct, {
            click_type: clickType,
            ecommerce: {
              items: [
                {
                  item_id: productCard.dataset.id,
                  item_variant_id: productCard.dataset.variantId,
                  item_name: productCard.dataset.title,
                  sku: productCard.dataset.sku,
                  item_brand: 'Boutique Gobelets',
                  item_category: productCard.dataset.category,
                  quantity: 1,
                },
              ],
            },
          })
            .then(() => {
              window.location = url;
            })
            .catch((error) => {
              console.error(error);
            });
      });
    });
  };

  handleNewsletterEvent = (form) => {
    form.addEventListener('submit', () => {
      const emailInput = form.querySelector(this.footerNeswletterInputSelector);

      if (emailInput && emailInput.value) {
        localStorage.setItem('lastSubmittedEmail', emailInput.value);
      }
    });

    if (window.newsletterFormSubmitted) {
      dataLayerPush(DataLayerEventsEnum.SubscribeNewsletter, {
        user_data: {
          email_address: `${localStorage.lastSubmittedEmail}`,
        },
      })
        .then(() => {
          localStorage.removeItem('lastSubmittedEmail');
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  getProductData = (handle) => {
    return fetch(window.Shopify.routes.root + `products/${handle}.js`).then(
      (response) => response.json()
    );
  };
}

;// ./src/js/ObfLinks.js
class ObfLinks {
  init = () => {
    this.eventTypes = ['mouseover', 'focusin'];

    this.links = document.querySelectorAll('[data-href]');

    if (this.links.length > 0) {
      this.eventTypes.forEach((eventType) => {
        document.addEventListener(eventType, () =>
          this.mouseOverHandler(this.links)
        );
      });

      this.links.forEach((item) => {
        item.addEventListener('click', () => this.clickHandler(item));
      });
    }
  };

  mouseOverHandler = (links) => {
    links.forEach((item) => this.transformHref(item));
    this.eventTypes.forEach((eventType) => {
      document.removeEventListener(eventType, this.mouseOverHandler);
    });
  };

  transformHref = (element) => {
    if (element.dataset.href) {
      element.href = atob(element.dataset.href);
      delete element.dataset.href;
    }
  };

  clickHandler = (item) => {
    this.transformHref(item);
    item.removeEventListener('click', this.clickHandler);
  };
}

;// ./src/js/ReadMore.js
class ReadMore {
  constructor() {
    this.readMoreSelector = '.read-more';
    this.readMoreContentSelector = '.read-more__content';
    this.readMoreContentExpanded = 'read-more__content--expanded';
    this.readMoreButtonSelector = '.read-more__button';
  }

  init = () => {
    const readMoreElements = document.querySelectorAll(this.readMoreSelector);
    if (!readMoreElements.length > 0) return;

    readMoreElements.forEach((readMore) => {
      const content = readMore.querySelector(this.readMoreContentSelector);
      const button = readMore.querySelector(this.readMoreButtonSelector);

      if (!content || !button) return;

      button.addEventListener('click', () => {
        if (content.classList.contains(this.readMoreContentExpanded)) {
          content.classList.remove(this.readMoreContentExpanded);
          button.textContent = window.themeVariables.strings.readMore;
        } else {
          content.classList.add(this.readMoreContentExpanded);
          button.textContent = window.themeVariables.strings.readLess;
        }
      });
    });
  };
}

;// ./src/js/CheckboxTermsCart.js
class CheckboxTermsCart {
  constructor() {
    this.formSelector = '.cart-form-js';
    this.checkBoxSelector = '#checkbox-terms-cond-cart';
    this.submitSelector = '.cart-form-js button[type="submit"]';
    this.checkBoxLabel = '.checkbox-terms-cart__label';
    this.cartDrawerSelector = '.cart-drawer';
  }

  init() {
    this.manageCheckBox();

    window.addEventListener('variant:add', () => {
      this.manageCheckBox();
    });

    window.addEventListener('cart:change', () => {
      this.manageCheckBox();
    });

    const cartDrawer = document.querySelector(this.cartDrawerSelector);
    if (!cartDrawer) return;

    cartDrawer.addEventListener('toggle', () => {
      if (cartDrawer.open) {
        this.manageCheckBox();
      }
    });
  }

  manageCheckBox = () => {
    const forms = document.querySelectorAll(this.formSelector);
    if (!forms.length > 0) return;

    forms.forEach((form) => {
      const checkbox = form.querySelector(this.checkBoxSelector);
      const submitButton = form.querySelector(this.submitSelector);
      const checkboxLabel = form.querySelector(this.checkBoxLabel);

      if (!checkbox || !submitButton || !checkboxLabel) return;

      // Delete old eventListener for avoid errors
      checkboxLabel.removeEventListener('click', this.handleCheckboxLabelClick);
      checkbox.removeEventListener('change', this.handleCheckboxChange);

      checkboxLabel.addEventListener('click', this.handleCheckboxLabelClick);
      checkbox.addEventListener('change', this.handleCheckboxChange);
    });
  };

  handleCheckboxLabelClick = (e) => {
    if (e.target.tagName !== 'A') {
      e.preventDefault();
      const checkbox = e.currentTarget
        .closest(this.formSelector)
        .querySelector(this.checkBoxSelector);
      const submitButton = e.currentTarget
        .closest(this.formSelector)
        .querySelector(this.submitSelector);

      if (checkbox.checked) {
        checkbox.checked = false;
        submitButton.setAttribute('disabled', '');
      } else {
        checkbox.checked = true;
        submitButton.removeAttribute('disabled');
      }
    }
  };

  handleCheckboxChange = (e) => {
    const checkbox = e.target;
    const submitButton = checkbox
      .closest(this.formSelector)
      .querySelector(this.submitSelector);

    checkbox.checked
      ? submitButton.removeAttribute('disabled')
      : submitButton.setAttribute('disabled', '');
  };
}

;// ./src/main.js











// JS goes here

/*
 * To use the WqAxeptio class, please uncomment the following lines
 * and complete them with your Axeptio credentials
 */

// window.axeptioSettings = {
//   clientId: 'PASTE HERE YOUR AXEPTIO clientId',
//   cookiesVersion: 'PASTE HERE YOUR AXEPTIO cookiesVersion',
// };

window.addEventListener('load', () => {
  const classes = [
    new WqAxeptio(),
    new Configurator(),
    new CupSwitcher(),
    new HelpBlock(),
    new Product(),
    new DataLayer(),
    new ObfLinks(),
    new ReadMore(),
    new CheckboxTermsCart(),
  ];
  classes.forEach((classe) => classe.init());
});

/******/ })()
;